module.exports = __webpack_public_path__ + "static/media/CPO_Release_Notes.d2ec521e.pdf";